import { forwardRef } from 'react'
import { inputClasses } from './Input'

const Textarea = forwardRef(function Textarea({ className = '', error, ...props }, ref) {
    return <textarea ref={ref} className={[inputClasses(error), className].join(' ')} {...props} />
})

export default Textarea
